export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            关于夫妻影院
          </h2>
          <p className="text-sm text-foreground-500">一群热爱影视的人，为你打造最好的追剧平台</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              夫妻影院创立于多年影视爱好者的共同梦想——让每个人都能轻松、免费地享受优质电视剧。
              我们从一个小众资源分享站起步，如今已成长为覆盖国产剧、韩剧、港剧、日剧、美剧等
              多元化内容的综合性在线观影平台，片库总量突破 5000 部，日均服务数十万剧迷。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              我们深知追剧人的期待——下班后的放松时刻，周末的治愈时光，深夜的情绪共鸣。
              因此我们坚持免费、高清、秒播三个核心承诺，不断优化视频加载速度和播放体验，
              让每一位来到夫妻影院的用户，都能找到属于自己的那份观影快乐。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              未来，夫妻影院将继续扩大片库覆盖，持续提升技术体验，成为国内最值得信赖的
              免费电视剧在线观看平台。感谢每一位剧迷的支持与陪伴。
            </p>

            <div className="flex flex-wrap items-center justify-center gap-6 mt-8 pt-6 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary-500">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">剧集片库</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-accent-500">30+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary-500">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-accent-500">5年</div>
                <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}